export const API_VERSION = '/v2';
